import { render, staticRenderFns } from "./rolesList.vue?vue&type=template&id=683c2bb5&scoped=true"
import script from "./rolesList.vue?vue&type=script&lang=js"
export * from "./rolesList.vue?vue&type=script&lang=js"
import style0 from "./rolesList.vue?vue&type=style&index=0&id=683c2bb5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683c2bb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('683c2bb5')) {
      api.createRecord('683c2bb5', component.options)
    } else {
      api.reload('683c2bb5', component.options)
    }
    module.hot.accept("./rolesList.vue?vue&type=template&id=683c2bb5&scoped=true", function () {
      api.rerender('683c2bb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/rolesList.vue"
export default component.exports